import {ChangeDetectorRef, Component, Input} from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {Compbaser} from "../../../components/compbaser/compbases";
import {Observable, interval} from "rxjs";
import {StoreSelectorsService} from "../../../services/store-selectors.service";
import {IAppStatic, IUser} from "../../../interfaces";
import * as Highcharts from 'highcharts';
import {Lib} from "../../../../libs/Lib";
import {startWith, switchMap} from 'rxjs/operators';
import {fadeTransition} from 'libs/basicTransition';
import {DEFAULT_SERVER_STATS_POLL} from "../../../common";

@Component({
    selector: 'app-overview-network-cpu',
    templateUrl: './overview-network-cpu.component.html',
    styleUrls: ['./overview-network-cpu.component.scss'],
    animations: [fadeTransition],
    standalone: false
})
export class OverviewNetworkCpuComponent extends Compbaser {

    _options;
    _chart: any;
    _ready = false;
    user: IUser;
    Highcharts: typeof Highcharts = Highcharts;
    chartOptions: Highcharts.Options;
    private appSettings: IAppStatic;

    @Input() enterpriseMode: boolean;
    @Input() serverName: string;
    @Input() header;

    constructor(private storeSelector: StoreSelectorsService, private _http: HttpClient, private cd: ChangeDetectorRef) {
        super();
        this.cod(
            storeSelector.getAppSettings()
                .subscribe((appSettings: IAppStatic) => {
                    this.appSettings = appSettings;
                })
        );
        this.cod(
            storeSelector.getUser()
                .subscribe((user: IUser) => {
                    this.user = user;
                })
        );
        setTimeout(() => {
            this.initGrapha();
            setInterval(() => {
                var point, newVal, inc;
                if (this._chart && this._chart.series) {
                    point = this._chart.series[0].points[0];
                    inc = Math.round((Math.random() - 0.5) * 100);
                    newVal = point.y + inc;
                    if (newVal < 0 || newVal > 200) {
                        newVal = point.y - inc;
                    }
                    if (newVal > 90) {
                        newVal = 80;
                    }
                    point.update(newVal);
                }
            }, 10000);

        }, 20);
    }

    logChartInstance(chart: Highcharts.Chart) {
        this._chart = chart;
    }

    chartCallback = (chart) => {
        setTimeout(() => {
            if (!chart || !chart.callback || chart.callback.length == 0) return;
            chart.reflow();
        }, 1);
    };

    public networkStatus() {
        let url;
        if (this.serverName) {
            if (this.serverName === 'ALL') {
                url = `${this.appSettings.globalService}/msInstanceStats`;
            } else {
                url = `${this.appSettings.globalService}/msInstanceStats/${this.serverName}`;
            }
        } else {
            url = `${this.appSettings.globalService}/msInstanceStats/${this.user.businessDomain.split('.')[0]}`;
        }
        this.cod(
            // interval(Lib.DevMode() ? 60000 : 30000)
            interval(DEFAULT_SERVER_STATS_POLL)
                .pipe(
                    startWith(0),
                    switchMap(() => this._http.get(url)))
                .subscribe((value: any) => {
                    if (!this._chart || !this._chart.series) return;
                    // let point, newVal, inc;
                    // point = this._chart.series[0].points[0];
                    // inc = value.networkCpuStats;
                    // newVal = point.y + inc;
                    // if (newVal < 0 || newVal > 200) {
                    //   newVal = point.y - inc;
                    // }
                    const point = this._chart.series[0].points[0];
                    point.update(value.netCpu);

                }, (e) => console.error(e))
        );
    }

    initGrapha() {

        const gaugeOptions = {
            chart: {
                type: 'solidgauge'
            },

            title: null,
            yAxis: {
                min: 0,
                max: 100,
                title: {
                    // text: '<br/><br/><span style="position: relative; top: 10px">net CPU</span>'
                }
            },
            credits: {
                enabled: false
            },
            series: [{
                name: 'Speed',
                data: [0],
                dataLabels: {
                    format:
                        '<div style="text-align:center">' +
                        '<span style="font-size:25px">{y}</span><br/>' +
                        '<span style="font-size:12px;opacity:1;color: var(--text-color1)">avg/cpu</span>' +
                        '</div>'
                },
                tooltip: {
                    valueSuffix: ' cpu/5sec'
                }
            }],
            pane: {
                center: ['50%', '85%'],
                size: '100%',
                startAngle: -90,
                endAngle: 90,
                background: {
                    backgroundColor:
                        Highcharts.defaultOptions.legend.backgroundColor || '#EEE',
                    innerRadius: '60%',
                    outerRadius: '100%',
                    shape: 'arc'
                }
            },
            exporting: {
                enabled: false
            },

            tooltip: {
                enabled: false
            },
            plotOptions: {
                solidgauge: {
                    dataLabels: {
                        y: 5,
                        borderWidth: 0,
                        useHTML: true
                    }
                }
            }
        };

        this._options = gaugeOptions;
        this.chartOptions = this._options;

        setTimeout(() => {
            this._ready = true;
            this.networkStatus();
        }, 2);
    }

    valueFormatting(event) {
        return "avg/cpu";
    }

    onSelect(event) {
    }
}
